import type { FC, ReactNode } from "react"

type Props = {
  children: ReactNode
  className?: string
}

export default function H4({
  children,
  className = "",
}: Props): ReturnType<FC<Props>> {
  const cs = ["text-lg", className].join(" ").trim()
  return <h4 className={cs}>{children}</h4>
}
